import { humanFileSize } from '../../../../common/util'

export const MAX_WORKFLOW_ASSET_BYTES = 20 * 1024 * 1024

const SPREADSHEET_CONTENT_TYPES = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/csv']

const PRESENTATION_CONTENT_TYPES = ['application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation']

const IMAGE_CONTENT_TYPES = ['image/gif', 'image/jpeg', 'image/png', 'image/webp']

const PROFILES: Record<string, { contentTypes: string[]; label: string }> = {
  pdf: { contentTypes: ['application/pdf'], label: 'PDF' },
  image: { contentTypes: IMAGE_CONTENT_TYPES, label: 'GIF, JPEG, PNG or WebP' },
  spreadsheet: { contentTypes: SPREADSHEET_CONTENT_TYPES, label: 'Excel or CSV' },
  presentation: { contentTypes: PRESENTATION_CONTENT_TYPES, label: 'PowerPoint' },
  document: {
    contentTypes: [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/json',
      'text/markdown',
      'text/plain',
      'image/jpeg',
      'image/png',
      ...SPREADSHEET_CONTENT_TYPES,
      ...PRESENTATION_CONTENT_TYPES,
    ],
    label: 'PDF, Word, text, image, spreadsheet or presentation',
  },
}

const profileOf = (subType: string) => (Object.hasOwn(PROFILES, subType) ? PROFILES[subType] : undefined)

export const contentTypesForProfile = (subType: string): string[] | undefined => profileOf(subType)?.contentTypes

export const hintForProfile = (subType: string): string | undefined => {
  const profile = profileOf(subType)
  return profile ? `${profile.label}, up to ${humanFileSize(MAX_WORKFLOW_ASSET_BYTES, false, 0)}` : undefined
}

export const mediaFileHintOf = (config: Record<string, unknown>): string | undefined =>
  typeof config.hint === 'string' ? config.hint : typeof config.subType === 'string' ? hintForProfile(config.subType) : undefined
